/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './NotificationsRpc';
import * as Queries from './NotificationsRpc.dfc.new';
import type { AdditionalContextArgs } from './NotificationsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetNotificationsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetNotificationsResponseType>,
    References.GetNotificationsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getNotifications', References.GetNotificationsResponseType>
        : References.GetNotificationsResponseType)
    | undefined;
};

export function useGetNotificationsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetNotificationsResponseType>,
    References.GetNotificationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNotificationsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_NOTIFICATIONS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getNotifications: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetNotificationsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetNotificationsQueryReturn<T>;
}

type UseGetNotificationsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetNotificationsResponseType>,
    References.GetNotificationsRequestType,
    T extends true
      ? Record<'getNotifications', References.GetNotificationsResponseType>
      : References.GetNotificationsResponseType
  >;

export function useGetNotificationsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetNotificationsResponseType>,
    References.GetNotificationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNotificationsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_NOTIFICATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getNotifications: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetNotificationsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetNotificationsLazyQueryReturn<T>;
}

type UseGetNotificationsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetNotificationsResponseType>,
    References.GetNotificationsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getNotifications', References.GetNotificationsResponseType>
    : References.GetNotificationsResponseType;
};

export function useGetNotificationsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetNotificationsResponseType>,
    References.GetNotificationsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetNotificationsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_NOTIFICATIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getNotifications: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetNotificationsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetNotificationsSuspenseQueryReturn<T>;
}

type UseMarkNotificationAsReadMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.MarkNotificationAsReadResponseType>,
    References.MarkNotificationAsReadRequestType,
    T extends true
      ? Record<
          'markNotificationAsRead',
          References.MarkNotificationAsReadResponseType
        >
      : References.MarkNotificationAsReadResponseType
  >;

export function useMarkNotificationAsReadMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.MarkNotificationAsReadResponseType>,
    References.MarkNotificationAsReadRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseMarkNotificationAsReadMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.MARK_NOTIFICATION_AS_READ_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            markNotificationAsRead: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseMarkNotificationAsReadMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseMarkNotificationAsReadMutationReturn<T>;
}

type UseMarkAllNotificationsAsReadMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.MarkAllNotificationsAsReadResponseType>,
    References.MarkAllNotificationsAsReadRequestType,
    T extends true
      ? Record<
          'markAllNotificationsAsRead',
          References.MarkAllNotificationsAsReadResponseType
        >
      : References.MarkAllNotificationsAsReadResponseType
  >;

export function useMarkAllNotificationsAsReadMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.MarkAllNotificationsAsReadResponseType>,
    References.MarkAllNotificationsAsReadRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseMarkAllNotificationsAsReadMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            markAllNotificationsAsRead: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseMarkAllNotificationsAsReadMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseMarkAllNotificationsAsReadMutationReturn<T>;
}

type UseDeleteNotificationMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DeleteNotificationResponseType>,
    References.DeleteNotificationRequestType,
    T extends true
      ? Record<'deleteNotification', References.DeleteNotificationResponseType>
      : References.DeleteNotificationResponseType
  >;

export function useDeleteNotificationMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteNotificationResponseType>,
    References.DeleteNotificationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteNotificationMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_NOTIFICATION_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteNotification: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteNotificationMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteNotificationMutationReturn<T>;
}
